import TableComponent from "app/common/Component/Table/TableComponent";
import { useStore } from "app/stores";
import React, { memo } from "react";
import { Grid, Tooltip } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { formatMoney, getDateTime } from "app/common/LocalFunction";
import IconPen from "app/common/Icon/IconPen";
import { observer } from "mobx-react";
import { width } from "dom-helpers";
import IconDelete from "app/common/Icon/IconDelete";
const ListRegisterMedicalSupply = () => {
  const { t } = useTranslation();
  const {
    handleOpenCreateOrEditMedicalPopup,
    handleChangeFormSearchMedical,
    pageRegisterMedicalSupplyOrder,
    searchRegisterMedical,
    handleOpenConfirmDelete,
    pagingRegisterMedicalSupplyOrder,
  } = useStore().patientManagementStore.registerMedicalSupplyStore;

  return (
    <Grid container spacing={1} className="justify-center cards-body pt-0">
      <Grid item xs={12}>
        <TableComponent
          showOrdinalNumbers
          titleNodata={t("noData")}
          data={pageRegisterMedicalSupplyOrder?.content || []}
          doubleClick={(patient) => {
            handleOpenCreateOrEditMedicalPopup(patient);
          }}
          // minWidth={"720px"}
          name="ListRegisterMedicalSupply"
          showMoreButton
          // minWidth="1000px"
          columns={[
            {
              title: t("action"),
              field: "action",
              align: "center",
              width: "70px",
              render: (row) => (
                <div className="flex-center gap-2">
                  <Tooltip title="Chỉnh sửa">
                    <div
                      onClick={() => {
                        handleOpenCreateOrEditMedicalPopup(row);
                      }}
                    >
                      <IconPen />
                    </div>
                  </Tooltip>
                  <Tooltip title="Xóa thẻ trả trước">
                    <div
                      className="flex"
                      onClick={() => {
                        handleOpenConfirmDelete(row?.id);
                      }}
                    >
                      <IconDelete />
                    </div>
                  </Tooltip>
                </div>
              ),
            },
            // {
            //   field: "clientCard.code",
            //   title: t("Mã thẻ trả trước"),
            //   render: (val) => (
            //     <span className="service-code">{val?.clientCard?.code}</span>
            //   ),
            // },
            {
              field: "clientCard.name",
              title: t("Tên vật tư"),
              render: (val) => (
                <>
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <span
                      className="service-name"
                      onClick={() => handleOpenCreateOrEditMedicalPopup(val)}
                    >
                      {val?.medicalSupplyName || val?.medicalSupplyName}
                    </span>
                    <i>
                      <span>
                        <Tooltip title="Đã thu">
                          <b style={{ color: "green" }}>
                            {formatMoney(
                              (val.amountActuallyPaid =
                                (+val.price || 0) * (+val.soldQuantity || 0) -
                                (+val.discount || 0) +
                                (+val.taxTotal || 0))
                            )}
                          </b>
                        </Tooltip>
                      </span>
                      /
                      <span>
                        <Tooltip title="Cần thu">
                          <b style={{ color: "red" }}>
                            {formatMoney(+val?.totalBillPatientPaid || 0)}
                          </b>
                        </Tooltip>
                      </span>
                    </i>
                  </div>
                </>
              ),
            },
            {
              field: "totalAmount",
              title: "Giá tiền",
              align: "right",
              render: (val) => formatMoney(val?.totalAmount),
            },
            {
              field: "soldQuantity",
              title: t("Số lượng"),
              align: "right",
            },
            {
              field: "percentDiscount",
              title: t("% giảm giá"),
              render: (val) =>
                val?.treatmentPlanCard ? "" : val?.percentDiscount,
              align: "right",
            },
            {
              field: "practitioner.staffName",
              title: t("Thành tiền"),
              width: "240px",
              render: (data) => {
                if (
                  data?.treatmentPlanCard &&
                  data?.treatmentPlanCard?.clientCard
                )
                  return "";
                return (
                  <div className="total-data-group">
                    <div className="flex justify-between">
                      Tổng tiền: <b>{formatMoney(data?.totalAmount)}</b>
                    </div>
                    <div className="flex justify-between">
                      Giảm giá: <b>{formatMoney(data?.discount)}</b>
                    </div>

                    <div className="flex justify-between">
                      <b
                        className="flex justify-between"
                        style={{ width: "100%" }}
                      >
                        Số tiền (sau giảm):{" "}
                        <b>
                          {formatMoney(
                            data?.totalAmount - (+data?.discount || 0)
                          )}
                        </b>
                      </b>
                    </div>
                    <div className="flex justify-between">
                      Vat: <b>{formatMoney(+data?.taxTotal)}</b>
                    </div>
                    <div
                      style={{
                        background: "#ccc",
                        width: "100%",
                        height: "1px",
                        margin: "4px 0",
                      }}
                    ></div>
                    <div className="flex justify-between">
                      <b
                        className="flex justify-between"
                        style={{ width: "100%" }}
                      >
                        Tổng thanh toán:{" "}
                        <b>
                          {formatMoney(
                            data?.totalAmount -
                              (+data?.discount || 0) +
                              (+data?.taxTotal || 0)
                          )}
                        </b>
                      </b>
                    </div>
                  </div>
                );
              },
            },
            {
              field: "clientCard.name",
              title: t("Liệu trình"),
              render: (val) => val?.treatmentPlanCard?.clientCard?.name,
            },
            {
              field: "clientCard.name",
              title: t("Ngày đăng ký"),
              render: (val) => getDateTime(val?.orderDate),
            },
            // {
            //   field: "clientCard.name",
            //   title: t("Ngày hết hạn sử dụng"),
            //   render: (val) => getDateTime(val?.endDate),
            // },

            // {
            //   field: "discount",
            //   title: t("Tiền giảm giá"),
            //   render: (val) => formatMoney(val?.discount),
            // },

            {
              field: "note",
              title: t("Ghi chú"),
            },
          ]}
          dataPagination={{
            pageIndex: searchRegisterMedical?.pageIndex,
            pageSize: searchRegisterMedical?.pageSize,
            totalElements: pageRegisterMedicalSupplyOrder?.totalElements,
            totalPages: pageRegisterMedicalSupplyOrder?.totalPages,
            setPageIndex: (pageIndex) =>
              handleChangeFormSearchMedical({ pageIndex }),
            setPageSize: (pageSize) =>
              handleChangeFormSearchMedical({ pageSize }),
          }}
        />
      </Grid>
    </Grid>
  );
};

export default memo(observer(ListRegisterMedicalSupply));
